import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const OAuthXCallback = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const error = params.get('error');

    if (error) {
      alert('Erro no login com X: ' + error);
      window.location.href = '/existence-plexo';
      return;
    }

    if (code) {
      // Salva o code (ou troca por token no backend)
      localStorage.setItem('x_code', code);
      alert('Conectado ao X! Token recebido.');
      window.location.href = '/existence-plexo';
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 to-black flex items-center justify-center text-white">
      <div className="text-center">
        <div className="animate-pulse text-2xl mb-4">Conectando ao X...</div>
        <div className="text-sm opacity-80">Não feche esta página</div>
      </div>
    </div>
  );
};

export default OAuthXCallback;
